import React, { useState } from "react";

const AIRPORTS = [
  { code: "KHI", name: "Karachi",      full: "Jinnah Int'l Airport",       country: "Pakistan" },
  { code: "LHE", name: "Lahore",       full: "Allama Iqbal Int'l Airport",  country: "Pakistan" },
  { code: "ISB", name: "Islamabad",    full: "New Islamabad Int'l Airport", country: "Pakistan" },
  { code: "DXB", name: "Dubai",        full: "Dubai Int'l Airport",         country: "UAE" },
  { code: "DOH", name: "Doha",         full: "Hamad Int'l Airport",         country: "Qatar" },
  { code: "KUL", name: "Kuala Lumpur", full: "KLIA Airport",                country: "Malaysia" },
  { code: "LHR", name: "London",       full: "Heathrow Airport",            country: "UK" },
  { code: "JFK", name: "New York",     full: "JFK Airport",                 country: "USA" },
  { code: "CDG", name: "Paris",        full: "Charles de Gaulle",           country: "France" },
  { code: "SIN", name: "Singapore",    full: "Changi Airport",              country: "Singapore" },
  { code: "BKK", name: "Bangkok",      full: "Suvarnabhumi Airport",        country: "Thailand" },
  { code: "AMS", name: "Amsterdam",    full: "Schiphol Airport",            country: "Netherlands" },
  { code: "FRA", name: "Frankfurt",    full: "Frankfurt Airport",           country: "Germany" },
  { code: "SYD", name: "Sydney",       full: "Kingsford Smith",             country: "Australia" },
  { code: "NRT", name: "Tokyo",        full: "Narita Airport",              country: "Japan" },
  { code: "LAX", name: "Los Angeles",  full: "LAX Airport",                 country: "USA" },
  { code: "CAI", name: "Cairo",        full: "Cairo Int'l Airport",         country: "Egypt" },
  { code: "DEL", name: "Delhi",        full: "Indira Gandhi Int'l",         country: "India" },
];

function getToday() {
  var d = new Date();
  return d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
}
function fmtDate(s) {
  var d = new Date(s + "T12:00:00");
  return d.toLocaleDateString("en-GB", { day:"2-digit", month:"short", year:"numeric" }).toUpperCase();
}
function fmt12(mins) {
  var h = Math.floor(mins/60)%24, m = mins%60;
  var ampm = h < 12 ? "am" : "pm";
  var hh = h===0 ? 12 : h>12 ? h-12 : h;
  return String(hh).padStart(2,"0") + ":" + String(m).padStart(2,"0") + ampm;
}
// Real flight data keyed by "AIRLINE|FROM|TO"
// Each entry: { legs: [ {flightNo, dep, arr, duration, aircraft, terminal_from, terminal_to} ] }
// For connecting flights, legs[0] goes to hub, legs[1] goes to destination
var REAL_FLIGHTS = {
  "EMIRATES|AMS|DXB": {legs:[{no:"EK 0148",dep:"03:30pm",arr:"01:25am",dur:"6hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|BKK|DXB": {legs:[{no:"EK 0373",dep:"11:55am",arr:"03:35pm",dur:"6hr(s) 40min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "EMIRATES|BKK|SIN": {legs:[{no:"EK 0421",dep:"09:35am",arr:"01:05pm",dur:"2hr(s) 30min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "EMIRATES|CAI|DXB": {legs:[{no:"EK 0928",dep:"01:00pm",arr:"07:00pm",dur:"4hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|CDG|DXB": {legs:[{no:"EK 0074",dep:"02:10pm",arr:"12:05am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 2",tt:"TERMINAL 3"}]},
  "EMIRATES|DEL|DXB": {legs:[{no:"EK 0512",dep:"11:30pm",arr:"01:30am",dur:"3hr(s) 30min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|DEL|LHR": {legs:[{no:"EK 0509",dep:"03:20am",arr:"06:55am",dur:"9hr(s) 5min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|DXB|AMS": {legs:[{no:"EK 0147",dep:"09:30am",arr:"01:30pm",dur:"7hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|DXB|BKK": {legs:[{no:"EK 0372",dep:"03:20am",arr:"01:20pm",dur:"7hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "EMIRATES|DXB|CAI": {legs:[{no:"EK 0927",dep:"09:05am",arr:"10:15am",dur:"3hr(s) 10min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|DXB|CDG": {legs:[{no:"EK 0073",dep:"07:55am",arr:"11:50am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 2"}]},
  "EMIRATES|DXB|DEL": {legs:[{no:"EK 0511",dep:"04:15am",arr:"09:15am",dur:"3hr(s) 30min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|DXB|FRA": {legs:[{no:"EK 0047",dep:"08:25am",arr:"12:15pm",dur:"6hr(s) 50min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 2"}]},
  "EMIRATES|DXB|ISB": {legs:[{no:"EK 0626",dep:"10:10pm",arr:"01:40am",dur:"2hr(s) 30min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"MAIN TERMINAL"}]},
  "EMIRATES|DXB|JFK": {legs:[{no:"EK 0201",dep:"02:15am",arr:"07:20am",dur:"14hr(s) 5min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}]},
  "EMIRATES|DXB|KHI": {legs:[{no:"EK 0608",dep:"10:05pm",arr:"02:05am",dur:"3hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"MAIN TERMINAL"}]},
  "EMIRATES|DXB|KUL": {legs:[{no:"EK 0342",dep:"03:50am",arr:"03:30pm",dur:"7hr(s) 40min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "EMIRATES|DXB|LAX": {legs:[{no:"EK 0215",dep:"03:20am",arr:"08:10am",dur:"16hr(s) 50min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}]},
  "EMIRATES|DXB|LHE": {legs:[{no:"EK 0624",dep:"09:55pm",arr:"01:25am",dur:"2hr(s) 30min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"MAIN TERMINAL"}]},
  "EMIRATES|DXB|LHR": {legs:[{no:"EK 0007",dep:"08:30am",arr:"12:05pm",dur:"7hr(s) 35min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|DXB|NRT": {legs:[{no:"EK 0318",dep:"10:00am",arr:"12:15am",dur:"9hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 2"}]},
  "EMIRATES|DXB|SIN": {legs:[{no:"EK 0346",dep:"02:35am",arr:"02:35pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "EMIRATES|DXB|SYD": {legs:[{no:"EK 0414",dep:"10:15pm",arr:"06:45pm",dur:"13hr(s) 30min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "EMIRATES|FRA|DXB": {legs:[{no:"EK 0048",dep:"02:25pm",arr:"12:00am",dur:"6hr(s) 35min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 2",tt:"TERMINAL 3"}]},
  "EMIRATES|ISB|DXB": {legs:[{no:"EK 0625",dep:"04:55am",arr:"06:10am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"}]},
  "EMIRATES|JFK|DXB": {legs:[{no:"EK 0202",dep:"11:00pm",arr:"08:05pm",dur:"12hr(s) 5min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 4",tt:"TERMINAL 3"}]},
  "EMIRATES|JFK|LHR": {legs:[{no:"EK 0002",dep:"11:00pm",arr:"11:10am",dur:"7hr(s) 10min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 4",tt:"TERMINAL 3"}]},
  "EMIRATES|KHI|DXB": {legs:[{no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"}]},
  "EMIRATES|KUL|DXB": {legs:[{no:"EK 0343",dep:"03:30pm",arr:"06:50pm",dur:"7hr(s) 20min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "EMIRATES|KUL|LHR": {legs:[{no:"EK 0066",dep:"11:55pm",arr:"05:35am",dur:"13hr(s) 40min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "EMIRATES|LAX|DXB": {legs:[{no:"EK 0216",dep:"11:35pm",arr:"04:00am",dur:"16hr(s) 25min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 4",tt:"TERMINAL 3"}]},
  "EMIRATES|LHE|DXB": {legs:[{no:"EK 0623",dep:"03:30am",arr:"04:45am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"}]},
  "EMIRATES|LHR|DEL": {legs:[{no:"EK 0510",dep:"09:35pm",arr:"12:05pm",dur:"9hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|LHR|DXB": {legs:[{no:"EK 0008",dep:"09:30pm",arr:"08:55am",dur:"7hr(s) 25min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 3"}]},
  "EMIRATES|LHR|JFK": {legs:[{no:"EK 0001",dep:"08:00am",arr:"10:30am",dur:"7hr(s) 30min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}]},
  "EMIRATES|LHR|KUL": {legs:[{no:"EK 0065",dep:"10:15am",arr:"08:15am",dur:"14hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "EMIRATES|LHR|NRT": {legs:[{no:"EK 0009",dep:"01:30pm",arr:"10:05am",dur:"11hr(s) 35min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 2"}]},
  "EMIRATES|LHR|SIN": {legs:[{no:"EK 0347",dep:"09:15am",arr:"06:15am",dur:"13hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "EMIRATES|NRT|DXB": {legs:[{no:"EK 0317",dep:"11:45pm",arr:"06:20am",dur:"11hr(s) 35min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 2",tt:"TERMINAL 3"}]},
  "EMIRATES|NRT|LHR": {legs:[{no:"EK 0010",dep:"11:25am",arr:"02:30pm",dur:"12hr(s) 5min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 2",tt:"TERMINAL 3"}]},
  "EMIRATES|SIN|BKK": {legs:[{no:"EK 0422",dep:"02:15pm",arr:"03:45pm",dur:"2hr(s) 30min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "EMIRATES|SIN|DXB": {legs:[{no:"EK 0347",dep:"12:05pm",arr:"04:05pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "EMIRATES|SIN|LHR": {legs:[{no:"EK 0346",dep:"11:35pm",arr:"04:30am",dur:"12hr(s) 55min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "EMIRATES|SIN|SYD": {legs:[{no:"EK 0404",dep:"09:00am",arr:"08:00pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "EMIRATES|SYD|DXB": {legs:[{no:"EK 0415",dep:"09:35am",arr:"04:35pm",dur:"14hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "EMIRATES|SYD|SIN": {legs:[{no:"EK 0403",dep:"04:15pm",arr:"09:15pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|AMS|DOH": {legs:[{no:"QR 0248",dep:"02:20pm",arr:"10:00pm",dur:"5hr(s) 40min(s)",ac:"BOEING 787-8",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|BKK|DOH": {legs:[{no:"QR 0835",dep:"09:15pm",arr:"11:15pm",dur:"6hr(s) 0min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|BKK|SIN": {legs:[{no:"QR 0969",dep:"10:30am",arr:"01:30pm",dur:"2hr(s) 0min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|CAI|DOH": {legs:[{no:"QR 0597",dep:"10:45am",arr:"03:15pm",dur:"3hr(s) 30min(s)",ac:"AIRBUS A320",tf:"TERMINAL 2",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|CDG|DOH": {legs:[{no:"QR 0040",dep:"03:00pm",arr:"11:15pm",dur:"6hr(s) 15min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 2",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|CDG|JFK": {legs:[{no:"QR 0025",dep:"10:20am",arr:"01:00pm",dur:"8hr(s) 40min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 2",tt:"TERMINAL 8"}]},
  "QATAR AIRWAYS|DEL|DOH": {legs:[{no:"QR 0555",dep:"12:50pm",arr:"02:10pm",dur:"3hr(s) 50min(s)",ac:"AIRBUS A320",tf:"TERMINAL 3",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|DEL|LHR": {legs:[{no:"QR 0557",dep:"07:45am",arr:"12:05pm",dur:"9hr(s) 50min(s)",ac:"BOEING 787-8",tf:"TERMINAL 3",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|DOH|AMS": {legs:[{no:"QR 0247",dep:"07:30am",arr:"12:10pm",dur:"6hr(s) 40min(s)",ac:"BOEING 787-8",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "QATAR AIRWAYS|DOH|BKK": {legs:[{no:"QR 0836",dep:"09:15am",arr:"09:00pm",dur:"7hr(s) 45min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|DOH|CAI": {legs:[{no:"QR 0598",dep:"08:00am",arr:"09:35am",dur:"2hr(s) 35min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"TERMINAL 2"}]},
  "QATAR AIRWAYS|DOH|CDG": {legs:[{no:"QR 0039",dep:"07:50am",arr:"12:55pm",dur:"7hr(s) 5min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 2"}]},
  "QATAR AIRWAYS|DOH|DEL": {legs:[{no:"QR 0556",dep:"06:25am",arr:"11:55am",dur:"3hr(s) 0min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"TERMINAL 3"}]},
  "QATAR AIRWAYS|DOH|DXB": {legs:[{no:"QR 0521",dep:"08:25am",arr:"10:35am",dur:"1hr(s) 10min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|DOH|FRA": {legs:[{no:"QR 0067",dep:"07:25am",arr:"11:30am",dur:"6hr(s) 5min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 2"}]},
  "QATAR AIRWAYS|DOH|ISB": {legs:[{no:"QR 0634",dep:"09:20pm",arr:"02:25am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"MAIN TERMINAL"}]},
  "QATAR AIRWAYS|DOH|JFK": {legs:[{no:"QR 0701",dep:"09:30am",arr:"03:25pm",dur:"13hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 8"}]},
  "QATAR AIRWAYS|DOH|KHI": {legs:[{no:"QR 0636",dep:"07:35pm",arr:"12:10am",dur:"2hr(s) 35min(s)",ac:"BOEING 787-8",tf:"TERMINAL 1",tt:"MAIN TERMINAL"}]},
  "QATAR AIRWAYS|DOH|KUL": {legs:[{no:"QR 0844",dep:"08:25pm",arr:"08:55am",dur:"7hr(s) 30min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|DOH|LAX": {legs:[{no:"QR 0741",dep:"10:30am",arr:"04:25pm",dur:"16hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|DOH|LHE": {legs:[{no:"QR 0632",dep:"08:30pm",arr:"01:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"MAIN TERMINAL"}]},
  "QATAR AIRWAYS|DOH|LHR": {legs:[{no:"QR 0003",dep:"07:55am",arr:"11:50am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A350-1000",tf:"TERMINAL 1",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|DOH|NRT": {legs:[{no:"QR 0806",dep:"09:35am",arr:"01:00am",dur:"9hr(s) 25min(s)",ac:"BOEING 787-8",tf:"TERMINAL 1",tt:"TERMINAL 2"}]},
  "QATAR AIRWAYS|DOH|SIN": {legs:[{no:"QR 0946",dep:"08:15am",arr:"08:30pm",dur:"7hr(s) 15min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|DOH|SYD": {legs:[{no:"QR 0908",dep:"09:45pm",arr:"07:45pm",dur:"14hr(s) 0min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|DXB|DOH": {legs:[{no:"QR 0522",dep:"11:00am",arr:"11:15am",dur:"1hr(s) 15min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|FRA|DOH": {legs:[{no:"QR 0068",dep:"01:45pm",arr:"09:00pm",dur:"5hr(s) 15min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 2",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|ISB|DOH": {legs:[{no:"QR 0633",dep:"04:55am",arr:"06:05am",dur:"3hr(s) 10min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|JFK|CDG": {legs:[{no:"QR 0026",dep:"10:45pm",arr:"12:10pm",dur:"7hr(s) 25min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 8",tt:"TERMINAL 2"}]},
  "QATAR AIRWAYS|JFK|DOH": {legs:[{no:"QR 0702",dep:"10:00pm",arr:"05:10pm",dur:"11hr(s) 10min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 8",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|JFK|LHR": {legs:[{no:"QR 0018",dep:"09:50pm",arr:"09:45am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 8",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|KHI|DOH": {legs:[{no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|KUL|DOH": {legs:[{no:"QR 0853",dep:"02:45am",arr:"04:05am",dur:"6hr(s) 20min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|KUL|LHR": {legs:[{no:"QR 0852",dep:"11:55pm",arr:"05:05am",dur:"13hr(s) 10min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|LAX|DOH": {legs:[{no:"QR 0742",dep:"09:25pm",arr:"11:40pm",dur:"15hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 4",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|LHE|DOH": {legs:[{no:"QR 0631",dep:"03:30am",arr:"04:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|LHR|DEL": {legs:[{no:"QR 0558",dep:"09:20pm",arr:"12:00pm",dur:"9hr(s) 10min(s)",ac:"BOEING 787-8",tf:"TERMINAL 4",tt:"TERMINAL 3"}]},
  "QATAR AIRWAYS|LHR|DOH": {legs:[{no:"QR 0004",dep:"08:30pm",arr:"05:10am",dur:"5hr(s) 40min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 4",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|LHR|JFK": {legs:[{no:"QR 0017",dep:"09:30am",arr:"12:05pm",dur:"7hr(s) 35min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 4",tt:"TERMINAL 8"}]},
  "QATAR AIRWAYS|LHR|KUL": {legs:[{no:"QR 0851",dep:"10:55am",arr:"08:00am",dur:"13hr(s) 5min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 4",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|LHR|NRT": {legs:[{no:"QR 0805",dep:"09:50pm",arr:"07:15pm",dur:"12hr(s) 25min(s)",ac:"BOEING 787-8",tf:"TERMINAL 4",tt:"TERMINAL 2"}]},
  "QATAR AIRWAYS|LHR|SIN": {legs:[{no:"QR 0007",dep:"09:30am",arr:"07:05am",dur:"13hr(s) 35min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 4",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|NRT|DOH": {legs:[{no:"QR 0807",dep:"02:00am",arr:"05:20am",dur:"9hr(s) 20min(s)",ac:"BOEING 787-8",tf:"TERMINAL 2",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|NRT|LHR": {legs:[{no:"QR 0808",dep:"02:05am",arr:"05:35am",dur:"12hr(s) 30min(s)",ac:"BOEING 787-8",tf:"TERMINAL 2",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|SIN|BKK": {legs:[{no:"QR 0968",dep:"03:00pm",arr:"04:00pm",dur:"2hr(s) 0min(s)",ac:"AIRBUS A320",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|SIN|DOH": {legs:[{no:"QR 0945",dep:"11:59pm",arr:"01:24am",dur:"6hr(s) 25min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|SIN|LHR": {legs:[{no:"QR 0006",dep:"11:35pm",arr:"05:30am",dur:"13hr(s) 55min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 4"}]},
  "QATAR AIRWAYS|SIN|SYD": {legs:[{no:"QR 0906",dep:"08:20am",arr:"07:10pm",dur:"7hr(s) 50min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|SYD|DOH": {legs:[{no:"QR 0909",dep:"10:35am",arr:"04:25pm",dur:"13hr(s) 50min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},
  "QATAR AIRWAYS|SYD|SIN": {legs:[{no:"QR 0907",dep:"05:00pm",arr:"10:00pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}]},

  "EMIRATES|KHI|LHR": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0007",dep:"08:30am",arr:"12:05pm",dur:"7hr(s) 35min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 3"}
  ]},
  "EMIRATES|LHR|KHI": {legs:[
    {no:"EK 0008",dep:"09:30pm",arr:"08:55am",dur:"7hr(s) 25min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 3"},
    {no:"EK 0608",dep:"10:05pm",arr:"02:05am",dur:"3hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"MAIN TERMINAL"}
  ]},
  "EMIRATES|KHI|JFK": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0201",dep:"02:15am",arr:"07:20am",dur:"14hr(s) 5min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}
  ]},
  "EMIRATES|JFK|KHI": {legs:[
    {no:"EK 0202",dep:"11:00pm",arr:"08:05pm",dur:"12hr(s) 5min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 4",tt:"TERMINAL 3"},
    {no:"EK 0608",dep:"10:05pm",arr:"02:05am",dur:"3hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"MAIN TERMINAL"}
  ]},
  "EMIRATES|KHI|SIN": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0346",dep:"02:35am",arr:"02:35pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|KHI|KUL": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0342",dep:"03:50am",arr:"03:30pm",dur:"7hr(s) 40min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|KHI|BKK": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0372",dep:"03:20am",arr:"01:20pm",dur:"7hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|KHI|CDG": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0073",dep:"07:55am",arr:"11:50am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 2"}
  ]},
  "EMIRATES|KHI|SYD": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0414",dep:"10:15pm",arr:"06:45pm",dur:"13hr(s) 30min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|KHI|NRT": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0318",dep:"10:00am",arr:"12:15am",dur:"9hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 2"}
  ]},
  "EMIRATES|KHI|LAX": {legs:[
    {no:"EK 0607",dep:"03:25am",arr:"04:25am",dur:"2hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0215",dep:"03:20am",arr:"08:10am",dur:"16hr(s) 50min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}
  ]},
  "EMIRATES|LHE|LHR": {legs:[
    {no:"EK 0623",dep:"03:30am",arr:"04:45am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0007",dep:"08:30am",arr:"12:05pm",dur:"7hr(s) 35min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 3"}
  ]},
  "EMIRATES|LHE|JFK": {legs:[
    {no:"EK 0623",dep:"03:30am",arr:"04:45am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0201",dep:"02:15am",arr:"07:20am",dur:"14hr(s) 5min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}
  ]},
  "EMIRATES|LHE|KUL": {legs:[
    {no:"EK 0623",dep:"03:30am",arr:"04:45am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0342",dep:"03:50am",arr:"03:30pm",dur:"7hr(s) 40min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|LHE|SIN": {legs:[
    {no:"EK 0623",dep:"03:30am",arr:"04:45am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0346",dep:"02:35am",arr:"02:35pm",dur:"8hr(s) 0min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|LHE|BKK": {legs:[
    {no:"EK 0623",dep:"03:30am",arr:"04:45am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0372",dep:"03:20am",arr:"01:20pm",dur:"7hr(s) 0min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "EMIRATES|ISB|LHR": {legs:[
    {no:"EK 0625",dep:"04:55am",arr:"06:10am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0007",dep:"08:30am",arr:"12:05pm",dur:"7hr(s) 35min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 3"}
  ]},
  "EMIRATES|ISB|JFK": {legs:[
    {no:"EK 0625",dep:"04:55am",arr:"06:10am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0201",dep:"02:15am",arr:"07:20am",dur:"14hr(s) 5min(s)",ac:"AIRBUS A380-800",tf:"TERMINAL 3",tt:"TERMINAL 4"}
  ]},
  "EMIRATES|ISB|KUL": {legs:[
    {no:"EK 0625",dep:"04:55am",arr:"06:10am",dur:"2hr(s) 15min(s)",ac:"BOEING 777-300ER",tf:"MAIN TERMINAL",tt:"TERMINAL 3"},
    {no:"EK 0342",dep:"03:50am",arr:"03:30pm",dur:"7hr(s) 40min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 3",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|KHI|LHR": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0003",dep:"07:55am",arr:"11:50am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A350-1000",tf:"TERMINAL 1",tt:"TERMINAL 4"}
  ]},
  "QATAR AIRWAYS|LHR|KHI": {legs:[
    {no:"QR 0004",dep:"08:30pm",arr:"05:10am",dur:"5hr(s) 40min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 4",tt:"TERMINAL 1"},
    {no:"QR 0636",dep:"07:35pm",arr:"12:10am",dur:"2hr(s) 35min(s)",ac:"BOEING 787-8",tf:"TERMINAL 1",tt:"MAIN TERMINAL"}
  ]},
  "QATAR AIRWAYS|KHI|JFK": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0701",dep:"09:30am",arr:"03:25pm",dur:"13hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 8"}
  ]},
  "QATAR AIRWAYS|KHI|KUL": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0844",dep:"08:25pm",arr:"08:55am",dur:"7hr(s) 30min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|KUL|KHI": {legs:[
    {no:"QR 0853",dep:"02:45am",arr:"04:05am",dur:"6hr(s) 20min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 1"},
    {no:"QR 0636",dep:"07:35pm",arr:"12:10am",dur:"2hr(s) 35min(s)",ac:"BOEING 787-8",tf:"TERMINAL 1",tt:"MAIN TERMINAL"}
  ]},
  "QATAR AIRWAYS|KHI|SIN": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0946",dep:"08:15am",arr:"08:30pm",dur:"7hr(s) 15min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|KHI|BKK": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0836",dep:"09:15am",arr:"09:00pm",dur:"7hr(s) 45min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|KHI|CDG": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0039",dep:"07:50am",arr:"12:55pm",dur:"7hr(s) 5min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 2"}
  ]},
  "QATAR AIRWAYS|KHI|SYD": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0908",dep:"09:45pm",arr:"07:45pm",dur:"14hr(s) 0min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|KHI|NRT": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0806",dep:"09:35am",arr:"01:00am",dur:"9hr(s) 25min(s)",ac:"BOEING 787-8",tf:"TERMINAL 1",tt:"TERMINAL 2"}
  ]},
  "QATAR AIRWAYS|KHI|LAX": {legs:[
    {no:"QR 0637",dep:"04:10am",arr:"05:00am",dur:"2hr(s) 50min(s)",ac:"AIRBUS A350-1000",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0741",dep:"10:30am",arr:"04:25pm",dur:"16hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 4"}
  ]},
  "QATAR AIRWAYS|LHE|LHR": {legs:[
    {no:"QR 0631",dep:"03:30am",arr:"04:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0003",dep:"07:55am",arr:"11:50am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A350-1000",tf:"TERMINAL 1",tt:"TERMINAL 4"}
  ]},
  "QATAR AIRWAYS|LHE|JFK": {legs:[
    {no:"QR 0631",dep:"03:30am",arr:"04:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0701",dep:"09:30am",arr:"03:25pm",dur:"13hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 8"}
  ]},
  "QATAR AIRWAYS|LHE|KUL": {legs:[
    {no:"QR 0631",dep:"03:30am",arr:"04:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0844",dep:"08:25pm",arr:"08:55am",dur:"7hr(s) 30min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|LHE|SIN": {legs:[
    {no:"QR 0631",dep:"03:30am",arr:"04:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0946",dep:"08:15am",arr:"08:30pm",dur:"7hr(s) 15min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|LHE|BKK": {legs:[
    {no:"QR 0631",dep:"03:30am",arr:"04:35am",dur:"3hr(s) 5min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0836",dep:"09:15am",arr:"09:00pm",dur:"7hr(s) 45min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|ISB|LHR": {legs:[
    {no:"QR 0633",dep:"04:55am",arr:"06:05am",dur:"3hr(s) 10min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0003",dep:"07:55am",arr:"11:50am",dur:"6hr(s) 55min(s)",ac:"AIRBUS A350-1000",tf:"TERMINAL 1",tt:"TERMINAL 4"}
  ]},
  "QATAR AIRWAYS|ISB|JFK": {legs:[
    {no:"QR 0633",dep:"04:55am",arr:"06:05am",dur:"3hr(s) 10min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0701",dep:"09:30am",arr:"03:25pm",dur:"13hr(s) 55min(s)",ac:"BOEING 777-300ER",tf:"TERMINAL 1",tt:"TERMINAL 8"}
  ]},
  "QATAR AIRWAYS|ISB|KUL": {legs:[
    {no:"QR 0633",dep:"04:55am",arr:"06:05am",dur:"3hr(s) 10min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0844",dep:"08:25pm",arr:"08:55am",dur:"7hr(s) 30min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
  "QATAR AIRWAYS|ISB|SIN": {legs:[
    {no:"QR 0633",dep:"04:55am",arr:"06:05am",dur:"3hr(s) 10min(s)",ac:"AIRBUS A320",tf:"MAIN TERMINAL",tt:"TERMINAL 1"},
    {no:"QR 0946",dep:"08:15am",arr:"08:30pm",dur:"7hr(s) 15min(s)",ac:"AIRBUS A350-900",tf:"TERMINAL 1",tt:"TERMINAL 1"}
  ]},
};

function getFallbackTerminal(code) {
  return (code==="KHI"||code==="LHE"||code==="ISB") ? "MAIN TERMINAL" : "TERMINAL 1";
}

function buildFlight(airline, fromCode, toCode, dateStr, seed) {
  var fromA = AIRPORTS.find(function(a){return a.code===fromCode;}) || {code:fromCode,name:fromCode,full:fromCode,country:""};
  var toA   = AIRPORTS.find(function(a){return a.code===toCode;})   || {code:toCode,name:toCode,full:toCode,country:""};

  var key = airline+"|"+fromCode+"|"+toCode;
  var realData = REAL_FLIGHTS[key];

  if (realData) {
    var isQatarR = airline==="QATAR AIRWAYS";
    var hubCodeR = isQatarR ? "DOH" : "DXB";
    var hubAR = AIRPORTS.find(function(a){return a.code===hubCodeR;}) || {code:hubCodeR,name:hubCodeR,full:hubCodeR,country:""};
    var numLegs = realData.legs.length;
    return {
      airline: airline, dateLabel: fmtDate(dateStr),
      legs: realData.legs.map(function(l, li){
        // For single leg: from=origin, to=destination
        // For multi leg: leg0 from=origin to=hub, leg1 from=hub to=destination
        var legFromA, legToA;
        if (numLegs === 1) {
          legFromA = fromA; legToA = toA;
        } else if (li === 0) {
          legFromA = fromA; legToA = hubAR;
        } else {
          legFromA = hubAR; legToA = toA;
        }
        return {
          flightNo: l.no,
          from:{code:legFromA.code, name:legFromA.full.toUpperCase(), country:legFromA.country.toUpperCase(), terminal:l.tf},
          to:  {code:legToA.code,  name:legToA.full.toUpperCase(),  country:legToA.country.toUpperCase(),  terminal:l.tt},
          dep:l.dep, arr:l.arr, duration:l.dur, aircraft:l.ac,
        };
      }),
    };
  }

  // Fallback: generate plausible flight for unknown routes
  var isQatar = airline==="QATAR AIRWAYS";
  var hubCode = isQatar ? "DOH" : "DXB";
  var hub = isQatar
    ? {code:"DOH",name:"Hamad Int'l Airport",country:"Qatar",terminal:"TERMINAL 1"}
    : {code:"DXB",name:"Dubai Int'l Airport",country:"UAE",terminal:"TERMINAL 3"};
  var prefix = isQatar ? "QR" : "EK";
  var ac = isQatar
    ? ["AIRBUS A350-1000","AIRBUS A350-900","BOEING 777-300ER","BOEING 787-8"]
    : ["BOEING 777-300ER","AIRBUS A380-800","BOEING 777-200LR","BOEING 787-9"];
  var d1=240+(seed%180), dur1=110+(seed%70), a1=d1+dur1;
  var lay=90+(seed%90), d2=a1+lay, dur2=360+(seed%240), a2=d2+dur2;
  var isDirect=(fromCode===hubCode||toCode===hubCode);
  if(isDirect){
    var dDur=90+(seed%120); var dArr=d1+dDur;
    return { airline:airline, dateLabel:fmtDate(dateStr), legs:[
      {flightNo:prefix+" 0"+(200+(seed%600)),
       from:{code:fromA.code,name:fromA.full.toUpperCase(),country:fromA.country.toUpperCase(),terminal:getFallbackTerminal(fromCode)},
       to:  {code:toA.code, name:toA.full.toUpperCase(), country:toA.country.toUpperCase(), terminal:getFallbackTerminal(toCode)},
       dep:fmt12(d1%1440),arr:fmt12(dArr%1440)+(dArr>=1440?" (Next Day)":""),
       duration:Math.floor(dDur/60)+"hr(s) "+dDur%60+"min(s)",aircraft:ac[seed%2]},
    ]};
  }
  return { airline:airline, dateLabel:fmtDate(dateStr), legs:[
    {flightNo:prefix+" 0"+(200+(seed%600)),
     from:{code:fromA.code,name:fromA.full.toUpperCase(),country:fromA.country.toUpperCase(),terminal:getFallbackTerminal(fromCode)},
     to:  {code:hub.code, name:hub.name.toUpperCase(), country:hub.country.toUpperCase(), terminal:hub.terminal},
     dep:fmt12(d1%1440),arr:fmt12(a1%1440)+(a1>=1440?" (Next Day)":""),
     duration:Math.floor(dur1/60)+"hr(s) "+dur1%60+"min(s)",aircraft:ac[seed%2]},
    {flightNo:prefix+" 0"+(700+((seed*3)%200)),
     from:{code:hub.code,name:hub.name.toUpperCase(),country:hub.country.toUpperCase(),terminal:hub.terminal},
     to:  {code:toA.code,name:toA.full.toUpperCase(),country:toA.country.toUpperCase(),terminal:getFallbackTerminal(toCode)},
     dep:fmt12(d2%1440),arr:fmt12(a2%1440)+(a2>=1440?" (Next Day)":""),
     duration:Math.floor(dur2/60)+"hr(s) "+dur2%60+"min(s)",aircraft:ac[(seed+1)%2+2]},
  ]};
}
function getFlights(from, to, depDate, retDate) {
  var s1=from.charCodeAt(0)*7+to.charCodeAt(0)*3;
  var s2=from.charCodeAt(0)*5+to.charCodeAt(0)*11+99;
  return [
    {outbound:buildFlight("QATAR AIRWAYS",from,to,depDate,s1),returnF:retDate?buildFlight("QATAR AIRWAYS",to,from,retDate,s1+37):null},
    {outbound:buildFlight("EMIRATES",from,to,depDate,s2),returnF:retDate?buildFlight("EMIRATES",to,from,retDate,s2+41):null},
  ];
}
function genCode(n) {
  n=n||6; var c="ABCDEFGHJKLMNPQRSTUVWXYZ23456789",o="";
  for(var i=0;i<n;i++) o+=c[Math.floor(Math.random()*32)];
  return o;
}

async function makePDF(passenger, fl, retFl, toCode) {
  if (!window.jspdf) {
    await new Promise(function(resolve,reject){
      var s=document.createElement("script");
      s.src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
      s.onload=resolve; s.onerror=reject;
      document.head.appendChild(s);
    });
  }
  var doc = new window.jspdf.jsPDF({unit:"pt",format:"a4"});
  var W=595.28, H=841.89;
  var toA=AIRPORTS.find(function(a){return a.code===toCode;});
  var res=genCode(), air=genCode();
  var pax=passenger.lastName.toUpperCase()+"/"+passenger.firstName.toUpperCase()+" MR";
  var destLabel=toA?toA.name.toUpperCase()+", "+toA.country.toUpperCase():toCode;

  function bf(style,size){doc.setFont("helvetica",style);doc.setFontSize(size);}
  function tc(r,g,b){doc.setTextColor(r,g,b);}
  function T(txt,x,y,opts){doc.text(String(txt),x,y,opts||{});}
  function hline(y2,x1,x2){doc.setDrawColor(190,190,190);doc.setLineWidth(0.4);doc.line(x1||28,y2,(x2||W-28),y2);}
  function vline(x2,y1,y2){doc.setDrawColor(190,190,190);doc.setLineWidth(0.4);doc.line(x2,y1,x2,y2);}
  function fillR(x,y,w,h,r,g,b){doc.setFillColor(r,g,b);doc.rect(x,y,w,h,"F");}
  function strokeR(x,y,w,h){doc.setDrawColor(190,190,190);doc.setLineWidth(0.4);doc.rect(x,y,w,h,"S");}

  fillR(0,0,W,H,255,255,255);

  // HEADER LINE
  var hy=22;
  bf("bold",9); tc(20,20,20); T(fl.dateLabel,28,hy);
  var cx=28+doc.getTextWidth(fl.dateLabel);
  if(retFl){
    bf("normal",9); tc(80,80,80); T(" > ",cx,hy); cx+=doc.getTextWidth(" > ");
    bf("bold",9); tc(20,20,20); T(retFl.dateLabel,cx,hy); cx+=doc.getTextWidth(retFl.dateLabel);
  }
  bf("normal",8); tc(110,110,110); T("  TRIP TO",cx,hy); cx+=doc.getTextWidth("  TRIP TO");
  bf("bold",11); tc(10,10,10); T("  "+destLabel,cx,hy);

  bf("normal",7); tc(110,110,110); T("PREPARED FOR",28,hy+14);
  bf("bold",9); tc(10,10,10); T(pax,28,hy+25);

  hline(hy+32);
  bf("normal",7); tc(110,110,110); T("RESERVATION CODE",28,hy+43); T("AIRLINE RESERVATION CODE",200,hy+43);
  bf("normal",8); tc(20,20,20); T(res,28,hy+53); T(air,200,hy+53);
  hline(hy+60);

  var y=hy+70;

  function drawSection(f){
    // Section header bar
    fillR(28,y,W-56,21,232,232,232);
    fillR(28,y,28,21,45,45,45);
    bf("bold",10); tc(255,255,255); T(">>",31,y+14);
    bf("normal",8); tc(50,50,50); T("DEPARTURE: ",62,y+14);
    bf("bold",9); tc(10,10,10); T(f.dateLabel,62+doc.getTextWidth("DEPARTURE: "),y+14);
    bf("normal",6.5); tc(140,140,140); T("Please verify flight times prior to departure",W-205,y+14);
    y+=21;

    f.legs.forEach(function(leg){
      var ch=96;
      fillR(28,y,W-56,ch,255,255,255);
      strokeR(28,y,W-56,ch);
      vline(175,y,y+ch);
      vline(295,y,y+ch);
      vline(415,y,y+ch);

      // Col 1: flight info
      bf("bold",8); tc(10,10,10); T(f.airline,33,y+13);
      bf("bold",10); tc(10,10,10); T(leg.flightNo,33,y+25);
      bf("normal",6.5); tc(90,90,90); T("Duration:",33,y+38);
      bf("normal",6.5); tc(20,20,20); T(leg.duration,33,y+47);
      bf("normal",6.5); tc(90,90,90); T("Class:",33,y+57); bf("normal",6.5); tc(20,20,20); T("Economy",33,y+66);
      bf("normal",6.5); tc(90,90,90); T("Status:",33,y+76); bf("normal",6.5); tc(20,20,20); T("Confirmed",33,y+85);

      // Col 2: FROM
      var fx=180;
      bf("bold",13); tc(10,10,10); T(leg.from.code,fx,y+17);
      bf("normal",6.5); tc(60,60,60); T(leg.from.name,fx,y+27); T(leg.from.country,fx,y+36);
      bf("normal",7); tc(90,90,90); T("Departing At:",fx,y+49);
      bf("bold",12); tc(10,10,10); T(leg.dep,fx,y+61);
      bf("normal",6.5); tc(90,90,90); T("Terminal:",fx,y+73); T(leg.from.terminal,fx,y+82);

      // Arrow
      bf("bold",11); tc(80,80,80); T(">",289,y+50);

      // Col 3: TO
      var tx=300;
      bf("bold",13); tc(10,10,10); T(leg.to.code,tx,y+17);
      bf("normal",6.5); tc(60,60,60); T(leg.to.name,tx,y+27); T(leg.to.country,tx,y+36);
      bf("normal",7); tc(90,90,90); T("Arriving At:",tx,y+49);
      bf("bold",12); tc(10,10,10); T(leg.arr,tx,y+61);
      bf("normal",6.5); tc(90,90,90); T("Terminal:",tx,y+73); T(leg.to.terminal,tx,y+82);

      // Col 4: Aircraft
      var rx=420;
      bf("normal",6.5); tc(80,80,80); T("Aircraft:",rx,y+13);
      bf("normal",6.5); tc(20,20,20); T(leg.aircraft,rx,y+22);
      bf("normal",6.5); tc(80,80,80); T("Distance (in Miles):",rx,y+34);
      bf("normal",6.5); tc(80,80,80); T("Stop(s): 0",rx,y+46);
      bf("normal",6.5); tc(80,80,80); T("Meals:",rx,y+58);
      bf("normal",6.5); tc(20,20,20); T("Meals",rx,y+67);

      y+=ch;
    });

    // Passenger strip
    strokeR(28,y,W-56,23);
    vline(W/2,y,y+23);
    bf("normal",7); tc(100,100,100); T("Passenger Name:",33,y+9); T("Seats:",W/2+5,y+9);
    bf("normal",7.5); tc(10,10,10); T(">> "+pax,33,y+19); T("Check-In Required",W/2+5,y+19);
    y+=31;
  }

  drawSection(fl);
  if(retFl){y+=14;drawSection(retFl);}
  return doc;
}

var STEPS=["Search","Select","Passenger","Itinerary"];

function getTheme(dark) {
  var gold="#c9a84c";
  var accent="#1a6fc4";
  if (dark) {
    var bdr="rgba(255,255,255,0.09)";
    return {
      gold: gold,
      page:{minHeight:"100vh",background:"linear-gradient(160deg,#0d0f17 0%,#111827 60%,#0d0f17 100%)",fontFamily:"Palatino Linotype,Book Antiqua,Palatino,serif",color:"#e8e0d0"},
      hdr:{background:"rgba(255,255,255,0.02)",borderBottom:"1px solid "+bdr,padding:"20px 40px",display:"flex",alignItems:"center",gap:14,justifyContent:"space-between"},
      logo:{width:44,height:44,borderRadius:"50%",background:"linear-gradient(135deg,"+gold+",#7a5a0a)",display:"flex",alignItems:"center",justifyContent:"center"},
      lt:{fontSize:20,fontWeight:700,letterSpacing:"0.07em",color:gold},
      ls:{fontSize:10,color:"#777",letterSpacing:"0.2em",textTransform:"uppercase"},
      wrap:{maxWidth:740,margin:"0 auto",padding:"44px 20px"},
      card:{background:"rgba(255,255,255,0.04)",border:"1px solid "+bdr,borderRadius:14,padding:34},
      sec:{fontSize:10,letterSpacing:"0.22em",textTransform:"uppercase",color:gold,marginBottom:22},
      g2:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18,marginBottom:18},
      fld:{display:"flex",flexDirection:"column",gap:6},
      lbl:{fontSize:10,letterSpacing:"0.16em",textTransform:"uppercase",color:"#999"},
      sel:{background:"rgba(255,255,255,0.05)",border:"1px solid "+bdr,borderRadius:8,padding:"11px 13px",color:"#e8e0d0",fontSize:14,fontFamily:"inherit",outline:"none",cursor:"pointer"},
      inp:{background:"rgba(255,255,255,0.05)",border:"1px solid "+bdr,borderRadius:8,padding:"11px 13px",color:"#e8e0d0",fontSize:14,fontFamily:"inherit",outline:"none"},
      err:{color:"#d97070",fontSize:11,marginTop:2},
      btn:{background:"linear-gradient(135deg,"+gold+",#7a5a0a)",color:"#0a0a0a",border:"none",borderRadius:8,padding:"13px 36px",fontSize:13,fontFamily:"inherit",fontWeight:700,letterSpacing:"0.1em",cursor:"pointer",textTransform:"uppercase"},
      btnO:{background:"transparent",color:gold,border:"1px solid rgba(201,168,76,0.35)",borderRadius:8,padding:"13px 28px",fontSize:13,fontFamily:"inherit",letterSpacing:"0.08em",cursor:"pointer",textTransform:"uppercase"},
      tog:{display:"flex",border:"1px solid rgba(201,168,76,0.3)",borderRadius:8,overflow:"hidden",width:"fit-content",marginBottom:26},
      tab:function(on){return{padding:"9px 26px",background:on?gold:"transparent",color:on?"#0a0a0a":gold,border:"none",cursor:"pointer",fontSize:13,fontFamily:"inherit",fontWeight:on?700:400};},
      steps:{display:"flex",alignItems:"flex-start",gap:6,marginBottom:34},
      dot:function(a,d){return{width:26,height:26,borderRadius:"50%",background:d?gold:a?"rgba(201,168,76,0.2)":"rgba(255,255,255,0.05)",border:"2px solid "+(a||d?gold:"rgba(255,255,255,0.1)"),display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:d?"#0a0a0a":a?gold:"#555",flexShrink:0};},
      dln:{flex:1,height:1,background:"rgba(255,255,255,0.07)",marginTop:12},
      dlb:function(a){return{fontSize:9,letterSpacing:"0.12em",color:a?gold:"#555",textTransform:"uppercase",marginTop:4,textAlign:"center"};},
      fc:function(sel){return{background:sel?"rgba(201,168,76,0.06)":"rgba(255,255,255,0.025)",border:"1px solid "+(sel?"rgba(201,168,76,0.45)":bdr),borderRadius:12,padding:22,marginBottom:14,cursor:"pointer"};},
      bdg:function(a){return{display:"inline-block",padding:"3px 11px",borderRadius:20,fontSize:10,fontWeight:700,letterSpacing:"0.1em",background:a==="QATAR AIRWAYS"?"rgba(120,0,55,0.35)":"rgba(200,0,0,0.18)",color:a==="QATAR AIRWAYS"?"#e8a0b5":"#f09595",border:"1px solid "+(a==="QATAR AIRWAYS"?"rgba(232,160,181,0.25)":"rgba(240,149,149,0.25)"),marginBottom:14};},
      rte:{display:"flex",alignItems:"center",gap:10,marginBottom:6},
      iata:{fontSize:22,fontWeight:700,letterSpacing:"0.04em"},
      cty:{fontSize:10,color:"#777",marginTop:2},
      arw:{flex:1,display:"flex",alignItems:"center",gap:4,color:gold},
      aln:{flex:1,height:1,background:"rgba(201,168,76,0.22)"},
      mta:{display:"flex",gap:20,fontSize:11,color:"#777",marginTop:3},
      retBorder:{marginTop:14,paddingTop:14,borderTop:"1px solid rgba(255,255,255,0.05)"},
      retLabel:{fontSize:10,color:gold,letterSpacing:"0.09em",marginBottom:8,textTransform:"uppercase"},
      legLabel:{fontSize:10,color:"#666",letterSpacing:"0.09em",marginBottom:7,textTransform:"uppercase"},
      summaryBox:{background:"rgba(201,168,76,0.05)",border:"1px solid rgba(201,168,76,0.13)",borderRadius:8,padding:"11px 16px",marginBottom:26,fontSize:12,color:"#aaa"},
      disclaimerBox:{background:"rgba(201,168,76,0.04)",border:"1px solid rgba(201,168,76,0.09)",borderRadius:8,padding:"10px 14px",marginBottom:22,fontSize:11,color:"#888",lineHeight:1.7},
      successTitle:{fontSize:22,fontWeight:700,color:gold,marginBottom:8},
      successSub:{fontSize:14,color:"#888",marginBottom:32},
      successFooter:{marginTop:28,fontSize:11,color:"#555",lineHeight:1.8},
    };
  } else {
    var bdrL="rgba(0,0,0,0.1)";
    return {
      gold: accent,
      page:{minHeight:"100vh",background:"linear-gradient(160deg,#f0f4ff 0%,#ffffff 50%,#eef2fb 100%)",fontFamily:"Palatino Linotype,Book Antiqua,Palatino,serif",color:"#1a1a2e"},
      hdr:{background:"#ffffff",borderBottom:"1px solid "+bdrL,padding:"20px 40px",display:"flex",alignItems:"center",gap:14,justifyContent:"space-between",boxShadow:"0 2px 12px rgba(0,0,0,0.06)"},
      logo:{width:44,height:44,borderRadius:"50%",background:"linear-gradient(135deg,#1a6fc4,#0d4a8f)",display:"flex",alignItems:"center",justifyContent:"center"},
      lt:{fontSize:20,fontWeight:700,letterSpacing:"0.07em",color:"#1a6fc4"},
      ls:{fontSize:10,color:"#888",letterSpacing:"0.2em",textTransform:"uppercase"},
      wrap:{maxWidth:740,margin:"0 auto",padding:"44px 20px"},
      card:{background:"#ffffff",border:"1px solid "+bdrL,borderRadius:14,padding:34,boxShadow:"0 4px 20px rgba(0,0,0,0.06)"},
      sec:{fontSize:10,letterSpacing:"0.22em",textTransform:"uppercase",color:"#1a6fc4",marginBottom:22},
      g2:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18,marginBottom:18},
      fld:{display:"flex",flexDirection:"column",gap:6},
      lbl:{fontSize:10,letterSpacing:"0.16em",textTransform:"uppercase",color:"#666"},
      sel:{background:"#f8faff",border:"1px solid #d0d8f0",borderRadius:8,padding:"11px 13px",color:"#1a1a2e",fontSize:14,fontFamily:"inherit",outline:"none",cursor:"pointer"},
      inp:{background:"#f8faff",border:"1px solid #d0d8f0",borderRadius:8,padding:"11px 13px",color:"#1a1a2e",fontSize:14,fontFamily:"inherit",outline:"none"},
      err:{color:"#c0392b",fontSize:11,marginTop:2},
      btn:{background:"linear-gradient(135deg,#1a6fc4,#0d4a8f)",color:"#ffffff",border:"none",borderRadius:8,padding:"13px 36px",fontSize:13,fontFamily:"inherit",fontWeight:700,letterSpacing:"0.1em",cursor:"pointer",textTransform:"uppercase"},
      btnO:{background:"transparent",color:"#1a6fc4",border:"1px solid rgba(26,111,196,0.4)",borderRadius:8,padding:"13px 28px",fontSize:13,fontFamily:"inherit",letterSpacing:"0.08em",cursor:"pointer",textTransform:"uppercase"},
      tog:{display:"flex",border:"1px solid rgba(26,111,196,0.3)",borderRadius:8,overflow:"hidden",width:"fit-content",marginBottom:26},
      tab:function(on){return{padding:"9px 26px",background:on?"#1a6fc4":"transparent",color:on?"#ffffff":"#1a6fc4",border:"none",cursor:"pointer",fontSize:13,fontFamily:"inherit",fontWeight:on?700:400};},
      steps:{display:"flex",alignItems:"flex-start",gap:6,marginBottom:34},
      dot:function(a,d){return{width:26,height:26,borderRadius:"50%",background:d?"#1a6fc4":a?"rgba(26,111,196,0.15)":"rgba(0,0,0,0.05)",border:"2px solid "+(a||d?"#1a6fc4":"rgba(0,0,0,0.15)"),display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:d?"#fff":a?"#1a6fc4":"#aaa",flexShrink:0};},
      dln:{flex:1,height:1,background:"rgba(0,0,0,0.08)",marginTop:12},
      dlb:function(a){return{fontSize:9,letterSpacing:"0.12em",color:a?"#1a6fc4":"#aaa",textTransform:"uppercase",marginTop:4,textAlign:"center"};},
      fc:function(sel){return{background:sel?"rgba(26,111,196,0.04)":"#fafbff",border:"1px solid "+(sel?"rgba(26,111,196,0.5)":bdrL),borderRadius:12,padding:22,marginBottom:14,cursor:"pointer",boxShadow:sel?"0 2px 12px rgba(26,111,196,0.1)":"none"};},
      bdg:function(a){return{display:"inline-block",padding:"3px 11px",borderRadius:20,fontSize:10,fontWeight:700,letterSpacing:"0.1em",background:a==="QATAR AIRWAYS"?"rgba(120,0,55,0.08)":"rgba(200,0,0,0.07)",color:a==="QATAR AIRWAYS"?"#7a0035":"#c00000",border:"1px solid "+(a==="QATAR AIRWAYS"?"rgba(120,0,55,0.2)":"rgba(200,0,0,0.2)"),marginBottom:14};},
      rte:{display:"flex",alignItems:"center",gap:10,marginBottom:6},
      iata:{fontSize:22,fontWeight:700,letterSpacing:"0.04em",color:"#1a1a2e"},
      cty:{fontSize:10,color:"#888",marginTop:2},
      arw:{flex:1,display:"flex",alignItems:"center",gap:4,color:"#1a6fc4"},
      aln:{flex:1,height:1,background:"rgba(26,111,196,0.2)"},
      mta:{display:"flex",gap:20,fontSize:11,color:"#888",marginTop:3},
      retBorder:{marginTop:14,paddingTop:14,borderTop:"1px solid rgba(0,0,0,0.06)"},
      retLabel:{fontSize:10,color:"#1a6fc4",letterSpacing:"0.09em",marginBottom:8,textTransform:"uppercase"},
      legLabel:{fontSize:10,color:"#999",letterSpacing:"0.09em",marginBottom:7,textTransform:"uppercase"},
      summaryBox:{background:"rgba(26,111,196,0.04)",border:"1px solid rgba(26,111,196,0.15)",borderRadius:8,padding:"11px 16px",marginBottom:26,fontSize:12,color:"#555"},
      disclaimerBox:{background:"rgba(26,111,196,0.03)",border:"1px solid rgba(26,111,196,0.1)",borderRadius:8,padding:"10px 14px",marginBottom:22,fontSize:11,color:"#888",lineHeight:1.7},
      successTitle:{fontSize:22,fontWeight:700,color:"#1a6fc4",marginBottom:8},
      successSub:{fontSize:14,color:"#888",marginBottom:32},
      successFooter:{marginTop:28,fontSize:11,color:"#aaa",lineHeight:1.8},
    };
  }
}

// Theme toggle button
function ThemeToggle(props) {
  var dark = props.dark;
  var onToggle = props.onToggle;
  return (
    <button
      onClick={onToggle}
      title={dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
      style={{
        width:40, height:40, borderRadius:"50%", border:"none", cursor:"pointer",
        background: dark ? "rgba(255,255,255,0.08)" : "rgba(26,111,196,0.1)",
        display:"flex", alignItems:"center", justifyContent:"center",
        transition:"all 0.3s ease", flexShrink:0,
      }}
    >
      {dark ? (
        // Sun icon for switching to light
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="5" stroke="#f0c040" strokeWidth="2"/>
          <line x1="12" y1="2" x2="12" y2="5" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="12" y1="19" x2="12" y2="22" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="2" y1="12" x2="5" y2="12" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="19" y1="12" x2="22" y2="12" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="4.22" y1="19.78" x2="6.34" y2="17.66" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
          <line x1="17.66" y1="6.34" x2="19.78" y2="4.22" stroke="#f0c040" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ) : (
        // Moon icon for switching to dark
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="#1a6fc4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
    </button>
  );
}

export default function App() {
  var s1=useState(1);           var step=s1[0],      setStep=s1[1];
  var s2=useState("return");    var tripType=s2[0],  setTripType=s2[1];
  var s3=useState("");          var from=s3[0],      setFrom=s3[1];
  var s4=useState("");          var to=s4[0],        setTo=s4[1];
  var s5=useState("");          var depDate=s5[0],   setDepDate=s5[1];
  var s6=useState("");          var retDate=s6[0],   setRetDate=s6[1];
  var s7=useState([]);          var flights=s7[0],   setFlights=s7[1];
  var s8=useState(null);        var selected=s8[0],  setSelected=s8[1];
  var s9=useState({firstName:"",lastName:"",email:""});var passenger=s9[0],setPassenger=s9[1];
  var s10=useState(null);       var pdfUrl=s10[0],   setPdfUrl=s10[1];
  var s11=useState({});         var errors=s11[0],   setErrors=s11[1];
  var s12=useState(false);      var busy=s12[0],     setBusy=s12[1];
  var s13=useState(true);       var dark=s13[0],     setDark=s13[1];
  var today=getToday();
  var S=getTheme(dark);
  var gold=S.gold;

  function doSearch(){
    var e={};
    if(!from) e.from="Select departure airport";
    if(!to) e.to="Select destination airport";
    if(from&&to&&from===to) e.to="Must differ from departure";
    if(!depDate) e.depDate="Select departure date";
    if(depDate&&depDate<today) e.depDate="Date cannot be in the past";
    if(tripType==="return"&&!retDate) e.retDate="Select return date";
    if(tripType==="return"&&retDate&&retDate<today) e.retDate="Date cannot be in the past";
    if(tripType==="return"&&retDate&&retDate<=depDate) e.retDate="Must be after departure";
    if(Object.keys(e).length){setErrors(e);return;}
    setErrors({});
    setFlights(getFlights(from,to,depDate,tripType==="return"?retDate:null));
    setSelected(null); setStep(2);
  }

  async function doReserve(){
    var e={};
    if(!passenger.firstName.trim()) e.firstName="Required";
    if(!passenger.lastName.trim()) e.lastName="Required";
    if(!passenger.email.trim()||!passenger.email.includes("@")) e.email="Valid email required";
    if(Object.keys(e).length){setErrors(e);return;}
    setErrors({}); setBusy(true);
    try{
      var d=await makePDF(passenger,flights[selected].outbound,flights[selected].returnF,to);
      setPdfUrl(URL.createObjectURL(d.output("blob")));
      setStep(4);
    }catch(ex){alert("PDF error: "+ex.message);}
    finally{setBusy(false);}
  }

  function reset(){
    setStep(1);setFrom("");setTo("");setDepDate("");setRetDate("");
    setPassenger({firstName:"",lastName:"",email:""});setSelected(null);setPdfUrl(null);setFlights([]);
  }

  var fromName=(AIRPORTS.find(function(a){return a.code===from;})||{}).name||"";
  var toName=(AIRPORTS.find(function(a){return a.code===to;})||{}).name||"";
  var planeFill = dark ? "#0a0a0a" : "#ffffff";

  return (
    <div style={S.page}>
      <div style={S.hdr}>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <div style={S.logo}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2A1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" fill={planeFill}/>
            </svg>
          </div>
          <div>
            <div style={S.lt}>AVEFLIGHT</div>
            <div style={S.ls}>Your Global Flight Reservation Platform</div>
          </div>
        </div>
        <ThemeToggle dark={dark} onToggle={function(){setDark(!dark);}}/>
      </div>

      <div style={S.wrap}>
        <div style={S.steps}>
          {STEPS.map(function(lbl,i){
            return (
              <React.Fragment key={i}>
                <div style={{textAlign:"center"}}>
                  <div style={S.dot(step===i+1,step>i+1)}>{step>i+1?"v":i+1}</div>
                  <div style={S.dlb(step>=i+1)}>{lbl}</div>
                </div>
                {i<3&&<div style={S.dln}/>}
              </React.Fragment>
            );
          })}
        </div>

        {step===1&&(
          <div style={S.card}>
            <div style={S.sec}>Find Your Flight</div>
            <div style={S.tog}>
              <button style={S.tab(tripType==="oneway")} onClick={function(){setTripType("oneway");}}>One Way</button>
              <button style={S.tab(tripType==="return")} onClick={function(){setTripType("return");}}>Return</button>
            </div>
            <div style={S.g2}>
              <div style={S.fld}>
                <label style={S.lbl}>From</label>
                <select style={S.sel} value={from} onChange={function(e){setFrom(e.target.value);}}>
                  <option value="">Select Airport</option>
                  {AIRPORTS.map(function(a){return <option key={a.code} value={a.code}>{a.code} - {a.name} ({a.country})</option>;})}
                </select>
                {errors.from&&<span style={S.err}>{errors.from}</span>}
              </div>
              <div style={S.fld}>
                <label style={S.lbl}>To</label>
                <select style={S.sel} value={to} onChange={function(e){setTo(e.target.value);}}>
                  <option value="">Select Airport</option>
                  {AIRPORTS.map(function(a){return <option key={a.code} value={a.code}>{a.code} - {a.name} ({a.country})</option>;})}
                </select>
                {errors.to&&<span style={S.err}>{errors.to}</span>}
              </div>
              <div style={S.fld}>
                <label style={S.lbl}>Departure Date</label>
                <input type="date" style={S.inp} min={today} value={depDate} onChange={function(e){setDepDate(e.target.value);}}/>
                {errors.depDate&&<span style={S.err}>{errors.depDate}</span>}
              </div>
              {tripType==="return"&&(
                <div style={S.fld}>
                  <label style={S.lbl}>Return Date</label>
                  <input type="date" style={S.inp} min={depDate||today} value={retDate} onChange={function(e){setRetDate(e.target.value);}}/>
                  {errors.retDate&&<span style={S.err}>{errors.retDate}</span>}
                </div>
              )}
            </div>
            <button style={S.btn} onClick={doSearch}>Search Flights</button>
          </div>
        )}

        {step===2&&(
          <div>
            <div style={S.sec}>Choose Your Airline</div>
            <div style={{marginBottom:18,fontSize:13,color:dark?"#888":"#666"}}>{fromName} to {toName} &nbsp;|&nbsp; {depDate}{tripType==="return"?" / "+retDate:""}</div>
            {flights.map(function(f,i){
              return (
                <div key={i} style={S.fc(selected===i)} onClick={function(){setSelected(i);}}>
                  <div style={S.bdg(f.outbound.airline)}>{f.outbound.airline}</div>
                  {f.outbound.legs.map(function(leg,j){
                    return (
                      <div key={j} style={{marginBottom:j<1?14:0}}>
                        <div style={S.legLabel}>Leg {j+1} - {leg.flightNo} - {f.outbound.dateLabel}</div>
                        <div style={S.rte}>
                          <div><div style={S.iata}>{leg.from.code}</div><div style={S.cty}>{leg.dep}</div></div>
                          <div style={S.arw}><div style={S.aln}/><span style={{fontSize:9,whiteSpace:"nowrap"}}>{leg.duration}</span><div style={S.aln}/><span>&gt;</span></div>
                          <div><div style={S.iata}>{leg.to.code}</div><div style={S.cty}>{leg.arr}</div></div>
                        </div>
                        <div style={S.mta}><span>{leg.aircraft}</span><span>Economy</span><span>Meals included</span></div>
                      </div>
                    );
                  })}
                  {f.returnF&&(
                    <div style={S.retBorder}>
                      <div style={S.retLabel}>Return Journey</div>
                      {f.returnF.legs.map(function(leg,j){
                        return (
                          <div key={j} style={{marginBottom:j<1?12:0}}>
                            <div style={S.legLabel}>Leg {j+1} - {leg.flightNo} - {f.returnF.dateLabel}</div>
                            <div style={S.rte}>
                              <div><div style={{fontSize:17,fontWeight:700,color:dark?"#e8e0d0":"#1a1a2e"}}>{leg.from.code}</div><div style={S.cty}>{leg.dep}</div></div>
                              <div style={S.arw}><div style={S.aln}/><span style={{fontSize:9,whiteSpace:"nowrap"}}>{leg.duration}</span><div style={S.aln}/><span>&gt;</span></div>
                              <div><div style={{fontSize:17,fontWeight:700,color:dark?"#e8e0d0":"#1a1a2e"}}>{leg.to.code}</div><div style={S.cty}>{leg.arr}</div></div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {selected===i&&<div style={{marginTop:10,fontSize:12,color:gold,textAlign:"right"}}>Selected</div>}
                </div>
              );
            })}
            <div style={{display:"flex",gap:10,marginTop:22}}>
              <button style={S.btnO} onClick={function(){setStep(1);}}>Back</button>
              <button style={{...S.btn,opacity:selected===null?0.4:1}} disabled={selected===null} onClick={function(){setErrors({});setStep(3);}}>Continue</button>
            </div>
          </div>
        )}

        {step===3&&(
          <div style={S.card}>
            <div style={S.sec}>Passenger Details</div>
            <div style={S.summaryBox}>
              {flights[selected]&&flights[selected].outbound.airline} &nbsp;|&nbsp; {fromName} to {toName} &nbsp;|&nbsp; {tripType==="return"?"Return":"One Way"}
            </div>
            <div style={S.g2}>
              <div style={S.fld}>
                <label style={S.lbl}>First Name</label>
                <input style={S.inp} placeholder="e.g. Ahmed" value={passenger.firstName} onChange={function(e){setPassenger({...passenger,firstName:e.target.value});}}/>
                {errors.firstName&&<span style={S.err}>{errors.firstName}</span>}
              </div>
              <div style={S.fld}>
                <label style={S.lbl}>Last Name</label>
                <input style={S.inp} placeholder="e.g. Raza" value={passenger.lastName} onChange={function(e){setPassenger({...passenger,lastName:e.target.value});}}/>
                {errors.lastName&&<span style={S.err}>{errors.lastName}</span>}
              </div>
              <div style={{...S.fld,gridColumn:"1 / -1"}}>
                <label style={S.lbl}>Email Address</label>
                <input type="email" style={S.inp} placeholder="your@email.com" value={passenger.email} onChange={function(e){setPassenger({...passenger,email:e.target.value});}}/>
                {errors.email&&<span style={S.err}>{errors.email}</span>}
              </div>
            </div>
            <div style={S.disclaimerBox}>
              This itinerary is for consulate / embassy visa purposes only. Not a real booking.
            </div>
            <div style={{display:"flex",gap:10}}>
              <button style={S.btnO} onClick={function(){setStep(2);}}>Back</button>
              <button style={{...S.btn,opacity:busy?0.65:1}} disabled={busy} onClick={doReserve}>{busy?"Generating PDF...":"Generate Itinerary PDF"}</button>
            </div>
          </div>
        )}

        {step===4&&(
          <div style={S.card}>
            <div style={{textAlign:"center",paddingTop:16,paddingBottom:8}}>
              <div style={{marginBottom:14}}>
                <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2A1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" fill={gold}/>
                </svg>
              </div>
              <div style={S.successTitle}>Your Itinerary is Ready</div>
              <div style={S.successSub}>{passenger.firstName} {passenger.lastName} &nbsp;|&nbsp; {flights[selected]&&flights[selected].outbound.airline}</div>
              <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
                {pdfUrl&&<a href={pdfUrl} target="_blank" rel="noreferrer" style={{...S.btn,textDecoration:"none",display:"inline-block"}}>View Itinerary PDF</a>}
                {pdfUrl&&<a href={pdfUrl} download={"itinerary-"+passenger.lastName+"-"+passenger.firstName+".pdf"} style={{...S.btnO,textDecoration:"none",display:"inline-block"}}>Download PDF</a>}
                <button style={S.btnO} onClick={reset}>New Search</button>
              </div>
              <div style={S.successFooter}>For visa application purposes only. Does not represent a real flight booking.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
